import React from 'react'

import { useModal } from '@hooks/contexts/ModalContext/ModalContext'
import { useStoryReader } from '@hooks/book/useStoryReader'
import { useAuthentication } from '@hooks/useAuthentication'
import { BuyAllPromotionProps } from './interface'

export function withBuyAllPromotion(Component: React.FC<BuyAllPromotionProps>) {
  function WithBuyAllPromotion(props: { isDrawer?: boolean }) {
    const { user, isAuthenticated, userCoin } = useAuthentication()

    const {
      bookBuyAllPromotionDetail: data,
      isOwner,
      totalPrice,
    } = useStoryReader()
    const changeEmailModal = useModal({ modal: 'changeEmail' }, true)
    const modal = useModal({ modal: 'buyAllPromotion' }, true)
    const loginModal = useModal({ modal: 'login' })
    const notEnoughCoinModal = useModal({
      modal: 'notEnoughCoin',
      modalProps: {
        describeText: 'เนื้อเรื่องที่คุณเลือกอ่านติดเหรียญอยู่',
        purposeText: 'เข้าถึงเนื้อหานี้',
      },
    })

    function showBuyAllPromotion() {
      let summaryCurrentCoin = 0
      if (userCoin.paidCoin) {
        summaryCurrentCoin += userCoin.paidCoin.value
      }

      if (userCoin.freeCoin) {
        summaryCurrentCoin += Math.floor(userCoin.freeCoin.value)
      }

      if (userCoin.thirdCoin) {
        summaryCurrentCoin += Math.floor(userCoin.thirdCoin.value)
      }

      if (data && summaryCurrentCoin >= data.afterDiscountPrice) {
        modal.show({
          bookId: data.id,
          title: data.title,
          totalChapter: data.bookChapterCount,
          discountType: data.discountType,
          discountValue: data.discountValue,
          afterDiscountPrice: data.afterDiscountPrice,
          summaryPriceBeforeDiscount: data.summaryPriceBeforeDiscount,
        })
      } else {
        notEnoughCoinModal.show()
      }
    }

    function handleBuyAllPromotion() {
      if (isAuthenticated) {
        if (user.emailEditable) {
          changeEmailModal.show({
            onSuccess: () => {
              showBuyAllPromotion()
            },
          })
        } else {
          showBuyAllPromotion()
        }
      } else {
        loginModal.show()
      }
    }

    const componentProps = {
      data,
      totalPrice,
      isOwner,
      isAuthenticated,
      handleBuyAllPromotion,
      ...props,
    }

    return <Component {...componentProps} />
  }

  return WithBuyAllPromotion
}
